<template>
	<div class="d-flex align-items-center gap-2">
		<Select2Locale :modelValue="selectValue" @update:modelValue="$emit('update:modelValue', $event)"
			:options="optionsColori" :placeholder="'Colore'" :disabled="disabled"
			style="width: 180px; flex: 0 0 auto;"></Select2Locale>
		<input type="color"
			class="form-control form-control-color p-1"
			:value="modelValue"
			:disabled="disabled"
			@input="$emit('update:modelValue', $event.target.value)"
			style="width: 38px; height: 31px; flex: 0 0 auto;">
	</div>
</template>

<script>
import Select2Locale from './Select2Locale.vue'
import { utils } from '../../assets/js/utils';

// Cache a livello di modulo: più ColorPicker nella stessa pagina condividono un'unica richiesta.
let _coloriCache = null;

export default {
	name: 'ColorPicker',

	components: {
		Select2Locale
	},

	props: {
		modelValue: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
	},

	emits: ['update:modelValue'],

	data() {
		return {
			arrayColori: []
		};
	},

	computed: {
		optionsColori() {
			return this.arrayColori.map(c => ({ id: c.COLORE, text: c.DESCRIZIONE }));
		},

		// Il colore corrente non sempre coincide (case sensitive) con un predefinito: l'input
		// nativo restituisce l'esadecimale minuscolo, i predefiniti sono salvati maiuscoli.
		// Se non c'è corrispondenza passiamo null a Select2Locale così mostra il placeholder
		// "Colore" invece del testo di default "Selezionare un elemento".
		selectValue() {
			var match = utils.array.select(this.arrayColori, 'COLORE', this.modelValue, 1)[0];
			if (match == undefined) {
				match = this.arrayColori.find(c => (c.COLORE || '').toUpperCase() == (this.modelValue || '').toUpperCase());
			}
			return match ? match.COLORE : null;
		},
	},

	created() {
		if (_coloriCache != null) {
			this.arrayColori = _coloriCache;
			return;
		}
		utils.get('theb/attivita/colori', {}, (response) => {
			if (response.esito == 0) {
				_coloriCache = response.data;
				this.arrayColori = response.data;
			}
		});
	},
};
</script>
